import { render, staticRenderFns } from "./Comfirm.vue?vue&type=template&id=fd173b78&scoped=true&"
import script from "./Comfirm.vue?vue&type=script&lang=js&"
export * from "./Comfirm.vue?vue&type=script&lang=js&"
import style0 from "./Comfirm.vue?vue&type=style&index=0&id=fd173b78&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd173b78",
  null
  
)

export default component.exports